import React, {useCallback, useContext, useEffect} from "react";
import {Grid} from "@material-ui/core";
import youStake from "../../../assets/imgs/you_stake.svg";
import {ButtonWidget} from "../../../widget/pub/button_widget";
import styled from "styled-components";
import {Skeleton} from "@material-ui/lab";
import {useWait} from "../../../utils/wait_fn";
import {HttpServer} from "../../../net/http_server";
import {getBalanceNumber} from "../../../utils/formatBalance";
import {ClaimsProvider} from "../list";

export const TopWidget: React.FC = () => {
    const {topData} = useContext(ClaimsProvider);

    /**
     * active_claim: 1

     closed_claim: 1
     my_active_claim: 1
     my_honors: 0
     total: 2
     */
    return (
        <Grid container spacing={5}>
            <CardWidget label={'Active Claims'} value={topData?.active_claim}/>
            <CardWidget label={'My applications'} value={topData?.my_active_claim}/>
            <CardWidget label={'Closed Claims'} value={topData?.closed_claim}/>
            <CardWidget label={'My assessed claims (closed)'} value={topData?.my_honors}/>
        </Grid>
    );
}

const CardWidget: React.FC<{ label: string, value?: any }> = ({label,value}) => {
    return (
        <CardStyle item md={3} sm={6} xs={12}>
            <div>
                <h2>{label}</h2>
                <h3>{value == null ?"--":value}</h3>
            </div>

        </CardStyle>

    );
}


const CardStyle = styled(Grid)`

  > div {
    height: 108px;
    width: 100%;
    background-color: white;
    padding: 8px;
    box-shadow: 0 12px 31px 3px rgba(0, 0, 0, 0.1);
    text-align: center;
    display: flex;
    flex-flow: column;
    justify-content: center;
    border-radius: 10px;

    h2 {
      margin-bottom: 15px;
      color: #333333;
    }
    h3{
      font-size: 26px;
      font-weight: bold;
      color: #270D4F;
    }
  }

`


